import { type UIAppConfig } from '@sydle/ui-app';
import { getConfig, Provider } from '@sydle/ui-utils';
import type { ActionResult, Context } from '@vaadin/router';
import { refreshHead, setLinkTags } from '../utils/utils';

export async function getListingPageMetadata(context: Context): Promise<ActionResult> {
  const provider = new Provider(document.documentElement);
  const pageName = context?.route?.name;

  let categoryId;
  let categoryIdentifier;
  let tagId;
  let tagIdentifier;
  let staticName;

  switch (pageName) {
    case 'category':
      categoryId = context.params['categoryId']?.toString();
      categoryIdentifier = context.params['categoryIdentifier']?.toString();
      break;

    case 'tag':
      tagId = context.params['tagId']?.toString();
      tagIdentifier = context.params['tagIdentifier']?.toString();
      break;

    case 'home':
      staticName = '';
      break;

    case 'search':
      staticName = 'search';
      break;
  }

  const getPageLinksInput = {
    categoryId,
    categoryIdentifier,
    tagId,
    tagIdentifier,
    staticName,
  };

  provider?.update?.('getPostsParams', getPageLinksInput);

  const getPostsInput = {
    params: {
      categoryId,
      categoryIdentifier,
      tagId,
      tagIdentifier,
    },
    pageIndex: 0,
    pageSize: 9,
  };

  if (!(window as any).preloadPostsList) {
    window.blogFacade?.getPageLinks(getPageLinksInput).then((response) => {
      if (response.error) {
        console.error(response.error);
      }
      setLinkTags(response.data || []);
    });

    pageName !== 'search' &&
      window.blogFacade?.getPosts(getPostsInput).then((response) => {
        if (response.error) {
          console.error(response.error);
        }

        const route = getConfig<UIAppConfig>('ui-app')?.routes.find((route) => route.name === pageName);
        const titleTemplate = (route?.dynamicTitle ? route?.titleTemplate : route?.title) || '';
        refreshHead(response.data, titleTemplate, response.data?.name, false);
      });
  }
}
